import { render, staticRenderFns } from "./OrganisationMain.vue?vue&type=template&id=01f5717c&scoped=true&"
import script from "./OrganisationMain.vue?vue&type=script&lang=js&"
export * from "./OrganisationMain.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationMain.vue?vue&type=style&index=0&id=01f5717c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5717c",
  null
  
)

export default component.exports